<button nxButton="secondary small" type="button"
  class="nx-margin-bottom-0 nx-margin-right-2xs wallet-balance-btn"
  [class.wallet-alert-amber]="walletAlertLevel === 'amber'"
  [class.wallet-alert-red]="walletAlertLevel === 'red'"
  *ngIf="userRole=='WorkShop' || DealerReg"
  [nxTooltip]="walletAlertLevel === 'amber' ? Messages.WALLET_AMBER_WARNING_MSG : walletAlertLevel === 'red' ? Messages.WALLET_RED_WARNING_MSG : null">
  <nx-icon name="product-money-suitcase" class="nx-margin-right-2xs"></nx-icon>
  Wallet balance : {{walletBalance}}
  <nx-icon *ngIf="walletAlertLevel === 'amber'" name="warning-o" class="nx-margin-left-2xs wallet-alert-icon"></nx-icon>
  <nx-icon *ngIf="walletAlertLevel === 'red'" name="warning-circle-o" class="nx-margin-left-2xs wallet-alert-icon"></nx-icon>
</button>
